export default __webpack_public_path__ + "static/shalini2-3a5c8e82aeb15680ff3f222f3987e912.jpg";